function QuickStatWidget({ title, value, children }) {
  return (
    <div className="flex flex-col h-[120px] border border-black p-3 flex-1 shadow">
        <div className="text-sm uppercase font-semibold">{title || ""}</div>
        <div className="my-auto text-2xl font-semibold overflow-auto">{children ? children : value}</div>
    </div>
  );
}

export default QuickStatWidget;